import { render, staticRenderFns } from "./nav-tab-menu.vue?vue&type=template&id=e442fd6a&scoped=true&"
import script from "./nav-tab-menu.vue?vue&type=script&lang=js&"
export * from "./nav-tab-menu.vue?vue&type=script&lang=js&"
import style0 from "./nav-tab-menu.vue?vue&type=style&index=0&id=e442fd6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e442fd6a",
  null
  
)

export default component.exports